import { Outlet } from 'react-router';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { useLocation } from 'react-router-dom';
import metadata from '../../metadata.json';
import { Helmet } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

export default function Layout() {
    window.scrollTo(0, 0);
    const location = useLocation();
    const searchUrl = location.pathname;

    // Find the most specific metadata match
    const currentData = metadata
        .filter(item => searchUrl.startsWith(item.url))
        .sort((a, b) => b.url.length - a.url.length)[0];

    const meta = currentData;

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>

                {/* SEO Meta Tags */}
                <meta name="description" content={meta.description} />
                <meta name="keywords" content={meta.keywords} />
                <link rel="canonical" href={meta.canonical} />

                {/* Open Graph Tags */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content={meta.ogurl} />
                <meta property="og:title" content={meta.ogtitle} />
                <meta property="og:description" content={meta.ogdescription} />
                <meta property="og:image" content={meta.ogimage} />

                {/* Twitter Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={meta.twittertitle} />
                <meta name="twitter:description" content={meta.twitterdescription} />
                <meta name="twitter:image" content={meta.twitterimage} />
            </Helmet>

            {!location.pathname.includes('device-report') &&
                !location.pathname.includes('requote') &&
                !location.pathname.includes('reexact-value') &&
                <Header />
            }

            <Toaster position="top-right" />
            <Outlet />

            {!location.pathname.includes('device-report') &&
                !location.pathname.includes('requote') &&
                !location.pathname.includes('reexact-value') &&
                <Footer />
            }
        </>
    );
}
